<template>
    <div v-if="!this.isMobile" class="w-100">
        <table v-if="!this.isMobile" class="table-fixed">
            <thead class="bg-light-blue table-head">
                <tr class="fsp14 neue-roman primary-grey">
                    <th class="w75">#</th>
                    <th class="w144">{{ this.$t('components.service.modal.InvoiceDetails.27') }}</th>
                    <th class="w140">{{ this.$t('components.service.modal.InvoiceDetails.25') }}</th>
                    <th class="w51 text-nowrap text-center">{{ this.$t('components.service.modal.InvoiceDetails.26') }}</th>
                </tr>
            </thead>
            <tbody class="">
                <tr v-for="callback in this.callbackContent" class="fsp12 table-row neue-roman">
                    <td class="primary-grey align-middle w75 text-truncate">{{ callback.code }}</td>
                    <td class="align-middle w144">
                        <div class="text-nowrap lh16">
                            → {{ this.formatDate(callback.dt_request) }}
                        </div>
                        <div class="text-nowrap lh16">
                            ← {{ this.formatDate(callback.dt_response) }}
                        </div>
                    </td>
                    <td class="align-middle w140">
                        <div class="d-flex align-items-center gap-1">
                            <div class="text-truncate lh16">{{ callback.response }}</div>
                            <Icon v-if="callback.response !== 'OK'" @click="this.copy(callback.response)" name="copy" class="c16 pointer" />
                        </div>
                    </td>
                    <td class="align-middle w51">
                        <div class="d-flex justify-content-center">
                            <Icon v-if="callback.success == '1'" name="check-mark" :color="{ 0: '#018A5A'}" class="c16" />
                            <Icon v-else name="close" :color="{ 0: '#FF0000'}" class="c16" />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="this.callbacks.length > 3" class="text-decoration-underline neue show-all" @click="showAll = !this.showAll">
            {{ !this.showAll ? this.$t('components.service.modal.InvoiceDetails.28') : this.$t('components.service.modal.InvoiceDetails.29') }}
            <Icon :name="!this.showAll ? 'chevron-down' : 'chevron-up'" :color="{ 0: '#122157'}" :stroke_width="3" class="c16 ml8" />
        </div>
    </div>
    <div v-else class="d-flex flex-column">
        <div v-for="callback in this.callbacks" class="fsp12 lh16 neue-roman d-flex flex-column gap-2 pb10 callback-item">
            <div class="d-flex justify-content-between align-items-center pt10">
                <div class="primary-grey text-nowrap">#</div>
                <div class="primary-grey">{{ callback.code }}</div>
            </div>
            <div class="d-flex justify-content-between align-items-center gap-2">
                <div class="primary-grey text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.23') }}</div>
                <div>→ {{ this.formatDate(callback.dt_request) }}</div>
            </div>
            <div class="d-flex justify-content-between align-items-center gap-2">
                <div class="primary-grey text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.24') }}</div>
                <div>← {{ this.formatDate(callback.dt_response) }}</div>
            </div>
            <div class="d-flex justify-content-between align-items-center gap-2">
                <div class="primary-grey text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.25') }}</div>
                <div class="d-flex align-items-center gap-1 min-w-0"><div class="text-truncate">{{ callback.response }}</div> 
                <Icon v-if="callback.response !== 'OK'" name="copy" class="c16 pointer" /></div>
            </div>
            <div class="d-flex justify-content-between align-items-center gap-2">
                <div class="primary-grey text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.26') }}</div>
                <div>
                    <Icon v-if="callback.success == '1'" name="check-mark" :color="{ 0: '#018A5A'}" class="c18" />
                    <Icon v-else name="close" :color="{ 0: '#FF0000'}" class="c16" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue';

export default {
    components: {
        Icon
    },
    props: {
        callbacks: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            showAll: false,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        callbackContent() {
            return this.showAll ? this.callbacks : this.callbacks.slice(0, 3);
        }
    },
    methods: {
        formatDate(date) {
            if(date.split(' ')[1]) {
                return date.split(' ')[0].split('-').reverse().join('.') + ' ' + date.split(' ')[1];
            }
            return date.split('-').reverse().join('.');
        },
        copy(text) {
            this.$lib.copyTextS(text, this.$store);
        }
    }
}
</script>

<style lang="scss" scoped>
.table-head {
    th {
        padding: 8px;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
    }
    th:first-child {
        border-top-left-radius: 8px;
    }
    th:last-child {
        border-top-right-radius: 8px;
    }
}
.table-row {
    border-bottom: 1px solid $primary-stroke;
    td {
        padding: 8px;

    }
    &:last-child {
        border-bottom: none;
    }
}

.table-fixed {
    table-layout: fixed;
    width: 100%;
}

.w140 {
    width: 140px;
}

.w144 {
    width: 144px;
}

.w51 {
    width: 51px;
}

.w75 {
    width: 75px;
}

.min-w-0 {
    min-width: 0;
}

.logo {
    width: 28px;
    height: 28px;
}

.show-all {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    text-decoration: underline;
    color: $menu-bg;
    font-size: 12px;
    line-height: 16px;
    background-color: $bg-light-blue;
    cursor: pointer;
    height: 32px;
}

.callback-item {
    border-bottom: 1px solid $primary-stroke;
    &:last-child {
        margin-bottom: 0px;
    }
}
</style>